/**
 * « Aujourd'hui » se lit à l'heure de l'appareil, jamais en UTC : à 00:30 à
 * Paris, on est déjà le lendemain alors que `toISOString()` dit encore la
 * veille. Le fuseau peut être imposé (tests, fuseau de l'entreprise).
 */

/** « 2026-10-17 » : le jour civil d'un instant dans le fuseau donné (l'appareil par défaut). */
export function localDay(at: Date | string, timeZone?: string): string {
  const date = typeof at === 'string' ? new Date(at) : at;
  return date.toLocaleDateString('sv-SE', timeZone ? { timeZone } : undefined);
}

/** Vrai quand l'instant tombe le même jour civil que `now`. */
export function isSameLocalDay(at: Date | string, now: Date, timeZone?: string): boolean {
  return localDay(at, timeZone) === localDay(now, timeZone);
}

/** Vrai quand la période [start, end) touche le jour civil de `now`. */
export function overlapsLocalDay(start: string, end: string | null | undefined, now: Date, timeZone?: string): boolean {
  const today = localDay(now, timeZone);
  const first = localDay(start, timeZone);
  const last = end ? localDay(new Date(new Date(end).getTime() - 1), timeZone) : first;
  return first <= today && today <= last;
}
